import { connect } from 'react-redux';
import { searchSelectors, contactSelectors } from '@lifesize/nucleus';
import actions from 'actions/StartCallModal';
import { START_CALL_FORM } from 'constants/StartCallModal';
import oneTimeMeetingFeatureSelector from 'selectors/contact';
import { loadContactManually } from 'actions/Contact';
import { checkForCustomEntry } from 'utils/call-utils';
import { reset } from 'redux-form';
import StartCallSearch from 'components/StartCallModal/StartCallSearch';
import selectors from 'selectors/startCallModal';
import _get from 'lodash/get';

const searchResults = [];

const mapDispatchToProps = (dispatch) => ({
  handleSelectContact: (contact) => {
    dispatch(loadContactManually(contact));
    if (contact.isCreateOneTime) {
      dispatch(actions.callOneTimeMeeting());
    } else {
      dispatch(actions.selectContactForCall(contact));
    }
    dispatch(reset(START_CALL_FORM));
    dispatch(actions.setFormFocus(false));
  },
  handleSelectCustomContact: (contact) => {
    dispatch(actions.selectCustomContactForCall(contact));
    dispatch(reset(START_CALL_FORM));
    dispatch(actions.setFormFocus(false));
  },
  clearSelectedCall: () => {
    dispatch(reset(START_CALL_FORM));
    dispatch(actions.selectContactForCall(null));
    dispatch(actions.setFormFocus(true));
  },
  handleSetIsFocused: (isFocused) => {
    dispatch(actions.setFormFocus(isFocused));
  },
  handleEnter: (selectedContact) => {
    dispatch(actions.selectContactForCall(selectedContact));
    dispatch(reset(START_CALL_FORM));
    dispatch(actions.setFormFocus(false));
  }
});

function getMaxItems({ allContacts, searchContacts, searchString }) {
  const includeCustomItem = checkForCustomEntry(searchString);
  let searchResultsLength = searchContacts.length;
  if (includeCustomItem) {
    searchResultsLength += 1;
  }

  if (searchResultsLength && searchString) {
    return Math.min(searchResultsLength === 1 ? 2 : searchResultsLength, 6);
  }

  if ((searchString && searchString.length) || !allContacts.length) {
    return 1;
  }

  return Math.min(allContacts.length, 6);
}

function mapStateToProps(state) {
  const allContacts = contactSelectors.favoritesSelector(state);
  const searchString = _get(state, 'app.form.startCallSearch.values.startCallSearch');
  const searchContacts = searchSelectors.searchContacts(state);
  const isFocused = _get(state, 'app.startCallModal.isFocused');
  const contact = selectors.getStartCallModalContact(state);
  const selectionIndex = _get(state, 'app.dropdown.selectionIndex');
  const showOneTimeMeetings = oneTimeMeetingFeatureSelector(state);
  const currentContact = contactSelectors.getContactByDialStringGenerator(state)(searchString);

  let selectedContact;
  if (searchContacts.length) {
    selectedContact = _get(searchContacts[selectionIndex], 'contact');
  } else {
    selectedContact = allContacts[selectionIndex];
  }

  if (selectionIndex > -1 && searchContacts.length === 0 && searchString) {
    selectedContact = {
      name: searchString,
      id: searchString,
      dialString: searchString,
      isManual: true
    };
  }

  const showCustomDial = checkForCustomEntry(searchString);
  const isSearching = _get(state, 'nucleus.directory.isSearching');

  let searchLength;
  if (!searchString && !showCustomDial) {
    searchLength = allContacts.length;
  } else {
    searchLength = searchContacts.length + (showCustomDial ? 1 : 0);
  }

  if (searchResults.length !== searchLength) {
    searchResults.length = searchLength;
  }

  return {
    allContacts,
    maxItems: getMaxItems({ allContacts, searchContacts, searchString }),
    searchContacts,
    searchString,
    showCustomDial,
    currentContact,
    contact,
    isFocused,
    selectedContact,
    searchResults,
    showOneTimeMeetings,
    isSearching
  };
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  handleSelectContact: (contact) => {
    let currentContact = contact;
    if (contact.isManual) {
      if (!stateProps.currentContact) {
        return dispatchProps.handleSelectCustomContact(currentContact);
      }
      currentContact = stateProps.currentContact;
    }
    return dispatchProps.handleSelectContact(currentContact);
  }
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(StartCallSearch);
